
import './App.css';
import Conditionreact from './Home';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       <Conditionreact/>
      </header>
    </div>
  );
}

export default App;
